import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from 'app/core/user/user.service';
import { InitialData } from 'app/modules/admin/manage-user/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _userService: UserService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        // API call to get users llst
        return this._userService.getUsersInitial()
            .pipe(
                map((users) => ({
                    users
                })
                ),
                catchError(err => {
                    this._userService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().users);
                })
            );
    }
}

class DefaultResponse implements InitialData {
    users: any = [];
}